var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldRenderItem)?_c('li',{class:{
    'active': _vm.isActive,
}},[(_vm.isVuePage)?_c('router-link',{attrs:{"to":_vm.href},nativeOn:{"click":function($event){return _vm.hideSidebarMenuOnMobile.apply(null, arguments)}}},[(Boolean(_vm.icon))?_c('i',{class:`fa fa-${_vm.icon}`}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+"\n    ")]):_c('a',{attrs:{"href":_vm.href}},[(Boolean(_vm.icon))?_c('i',{class:`fa fa-${_vm.icon}`}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }